import { useContext } from "react";

import { ToastContext } from "../providers/ToastProvider";

export const useSnackbar = () => {
  const toastHelpers = useContext(ToastContext);
  return toastHelpers;
};
